import { gql } from '@apollo/client';

import { useDuplicateLicenseQuery } from './__graphql__/useDuplicateLicense';

type DuplicatedResult = {
  loading: boolean;
  duplicatedProductNames: (string | null | undefined)[];
  hasDuplicatedProducts: boolean;
};

export const useDuplicateLicense = (): DuplicatedResult => {
  const { data, loading } = useDuplicateLicenseQuery();

  const licenses =
    data?.userV2?.__typename === 'AuthenticatedUser'
      ? data?.userV2?.licenses.map((license) => license?.licensedproduct_id)
      : [];

  const virtualCartItems = data?.magento2?.customerCart?.items?.filter(
    (item) => item?.__typename === 'Magento2_VirtualCartItem',
  );

  const ownedProductsNames = virtualCartItems
    ?.filter((item) => licenses.includes(Number(item?.product.sdbsId)))
    ?.map((item) => item?.product.name);

  return {
    loading,
    duplicatedProductNames: ownedProductsNames ?? [],
    hasDuplicatedProducts: Boolean(ownedProductsNames?.length),
  };
};

export const DUPLICATE_LICENSE_QUERY = gql`
  query DuplicateLicense {
    magento2 {
      customerCart {
        id
        items {
          __typename
          id
          product {
            id
            sdbsId
            name
          }
        }
      }
    }

    userV2 {
      __typename
      ... on AuthenticatedUser {
        id
        licenses {
          licensedproduct_id
        }
      }
    }
  }
`;
